export function basicInfo(data,getMoney) {
  return {
    //转融通
    refinancingaHeaderConfig: {
      column: [{
        label: "项目编号",
        prop: "number"
      },{
        label: "项目类型",
        prop: "peojectTypeTran"      
      },{
        label: "借券机构",
        prop: "projectRefinancing.securitiesInstitution",
      },{
        label: "借券标的",
        prop: "projectRefinancing.securitiesObject"
      },{
        label: "借券股数",
        prop: "projectRefinancing.securitiesNum",
        append: '万股',
      },{
        label: "年化利率",
        // prop: "projectRefinancing.interest"
        prop: 'arrTran'
      }],
      firstsblock: {
        formatter: (row) => {
          console.log("firstsblock",row)
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },

      firstrow: {
        formatter: () => {
          return {
            width: "35%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "30%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "35%",
          };
        },
      }
    },
    //转融通
    refinancingConfig: {
      column: [{
        label: "项目名称",
        prop: "name",
      },{
        label: "项目编号",
        prop: "number"
      },{
        label: "项目类型",
        prop: "peojectTypeTran"
      },{
        label: "借券机构",
        prop: "projectRefinancing.securitiesInstitution"
      },{
        label: "借券标的",
        prop: "projectRefinancing.securitiesObject"
      },{
        label: "借券股数",
        prop: "securitiesNumTran"
      },{
        label: "年化利率",
        prop: "arrTran"
      },{
        label: "出借日收盘价",
        prop: "lendingDayPriceTran"
      },{
        label: "实际出借天数",
        prop: "realLendingDaysTran"
      },{
        label: "起始日期",
        prop: "projectRefinancing.lendingDate"
      },{
        label: "还券日期",
        prop: "projectRefinancing.repaymentDate"
      },{
        label: "转融通利息收入",
        prop: "interestTran"
      },{
        label: "权益补偿金",
        prop: "compensationTran"
      },
      // {
      //   label: "证券编号",
      //   prop: "projectRefinancing.securitiesNo"
      // },{
      //   label: "证券名称",
      //   prop: "projectRefinancing.securitiesName"
      // },{
      //   label: "证券数量",
      //   prop: "projectRefinancing.securitiesNum",
      //   append: '股'
      // },{
      //   label: "利息收入",
      //   prop: "interestTran",
      // },
      {
        label: "经办人",
        prop: "managerUserName"
      },{
        label: "备注",
        prop: "remarks",
        span: 24
      },{
        label: "附件",
        prop: 'fileName',
        slot: true,
        style: "width: 100%"
      }],
      firstsblock: {
        formatter: () => {
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },
      firstrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      }      
    },
    // 委托贷款
    loanInstitutionHeaderConfig: {
      column: [{
        label: "项目编号",
        prop: "number"
      },{
        label: "项目类型",
        prop: "peojectTypeTran"
      },{
        label: "授信额度",
        prop: "creditNumTran",
        append: '万元',
      },{
        label: "融资方",
        prop: "custName",
        // url: ''
      },{
        label: "出资方",
        prop: 'projectEntrustLoans.investor',
      },{
        label: "还款明细",
        prop: 'creditTimeStr',
        style: 'width:100%;'
      }],
      firstsblock: {
        formatter: () => {
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },
      firstrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      }
    },
    // 委托贷款
    loanInstitutionConfig: {
      column: [{
        label: "项目名称",
        prop: "name",
      },{
        label: "项目编号",
        prop: "number"
      },{
        label: "项目类型",
        prop: "peojectTypeTran"
      },{
        label: "出资方",
        prop: 'projectEntrustLoans.investor',
      },{
        label: "融资方",
        prop: 'custName',
        // url: ''
      },{
        label: "授信额度",
        append: '万元',
        prop: 'creditNumTran',
      },{
        label: "年化收益率",
        prop: 'arrTran',
        append: '%'
      },{
        label: "还款明细",
        prop: 'creditTimeStr',
        style: 'width:100%'
      },{
        label: "资金用途",
        prop: "projectEntrustLoans.useType",
        style: 'width:100%'
      },{
        label: "经办人",
        prop: "managerUserName",
        style: 'width:100%'
      },{
        label: "还款来源",
        prop: "projectEntrustLoans.repaymentSource",
        style: 'width:100%'
      },{
        label: "还款方式",
        prop: "projectEntrustLoans.repaymentType",
        style: 'width:100%'
      },{
        label: "备注",
        prop: "remarks",
        style: 'width:100%'
      },{
        label: "附件",
        prop: 'fileName',
        slot: true,
        style: "width: 100%"
      }],
      firstsblock: {
        formatter: () => {
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },
      firstrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      }      
    },
    // 信托
    loanInstitutionHeaderConfigTwo: {
      column: [{
        label: "项目编号",
        prop: "number"
      },{
        label: "项目类型",
        prop: "peojectTypeTran"
      },{
        label: "授信额度",
        prop: "creditNumTran",
        append: '万元',
      },{
        label: "融资方",
        prop: "custName",
      },{
        label: "出资方",
        prop: 'projectFinancialLoans.investor',
      },{
        label: "还款明细",
        prop: 'creditTimeStr',
        style: 'width:100%;'
      }],
      firstsblock: {
        formatter: () => {
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },
      firstrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      }      
    },
    // 信托
    loanInstitutionConfigTwo: {
      column: [{
        label: "项目名称",
        prop: "name",
      },{
        label: "项目编号",
        prop: "number"
      },{
        label: "项目类型",
        prop: "peojectTypeTran"
      },{
        label: "出资方",
        prop: 'projectFinancialLoans.investor',
      },{
        label: "融资方",
        prop: 'custName',
      },{
        label: "授信额度",
        append: '万元',
        prop: 'creditNumTran',
      },{
        label: "年化收益率",
        prop: 'arrTran',
        append: '%'
      },{
        label: "还款明细",
        prop: 'creditTimeStr',
        style: 'width:100%'
      },{
        label: "资金用途",
        prop: "projectFinancialLoans.useType",
        style: 'width:100%'
      },{
        label: "经办人",
        prop: "managerUserName",
        style: 'width:100%'
      },{
        label: "还款来源",
        prop: "projectFinancialLoans.repaymentSource",
        style: 'width:100%'
      },{
        label: "还款方式",
        prop: "projectFinancialLoans.repaymentType",
        style: 'width:100%'
      },{
        label: "备注",
        prop: "remarks",
        style: 'width:100%'
      }],
      firstsblock: {
        formatter: () => {
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },
      firstrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      }      
    },    
    // 定增
    setTheGainHeaderConfig: {
      column: [{
        label: "项目编号",
        prop: "number"
      },{
        label: "项目类型",
        prop: "peojectTypeTran"
      },{
        label: "证券名称",
        prop: "projectAdditionalStock.securitiesName",
        
      },{
        label: "证券编号",
        prop: "projectAdditionalStock.securitiesNo",
        
      },{
        label: "实际中标价值",
        prop: 'projectAdditionalStock.actualValue',
        append: '万元'
      },{
        label: "实际中标数量",
        prop: 'projectAdditionalStock.actualNum',
        append: '股'
      }],
      firstsblock: {
        formatter: () => {
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },
      firstrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      }      
    },
    setTheGainConfig: {
      column: [{
        label: "项目名称",
        prop: "name",
      },{
        label: "项目编号",
        prop: "number"
      },{
        label: "项目类型",
        prop: "peojectTypeTran"
      },{
        label: "证券名称",
        prop: "projectAdditionalStock.securitiesName"
      },{
        label: "拟参与的价值",
        prop: "projectAdditionalStock.planValue",
        append: '元'
      },{
        label: "拟参与的数量",
        prop: "projectAdditionalStock.planNum",
        append:'股'
      },{
        label: "实际中标价值",
        prop: "projectAdditionalStock.actualValue",
        append: '元'
      },{
        label: "实际中标数量",
        prop: "projectAdditionalStock.actualNum",
        append: '股'
      },{
        label: "经办人",
        prop: "managerUserName"
      },{
        label: "备注",
        prop: "remarks"
      },{
        label: "附件",
        prop: 'fileName',
        slot: true,
        style: "width: 100%"
      }],
      firstsblock: {
        formatter: () => {
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },
      firstrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      }      
    },
    
  }
}